import _toConsumableArray from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _objectSpread from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
export default {
  name: "popup",
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: true
    }
  },
  data: function data() {
    return {
      baseConfig: {
        visible: false
      },
      _content: undefined,
      _fn: undefined
    };
  },
  methods: {
    close: function close() {
      this.baseConfig.visible = false;
    },
    content: function content(_content) {
      if (typeof _content === "function") {
        this._content = _content;
      }
      return this;
    },
    confirm: function confirm(fn) {
      if (typeof fn === "function") {
        this._fn = fn;
      }
    }
  },
  created: function created() {
    this.baseConfig = Object.assign(this.baseConfig, this.config);
  },
  render: function render(h) {
    var _this = this;
    return h("el-dialog", {
      props: _objectSpread({}, this.baseConfig),
      on: {
        close: function close() {
          _this.close();
        }
      }
    }, function () {
      var foot = h("span", {
        slot: "footer",
        class: "dialog-footer"
      }, [h("el-button", {
        on: {
          click: function click() {
            _this.close();
          }
        }
      }, "取消"), h("el-button", {
        attrs: {
          type: "primary"
        },
        on: {
          click: function click() {
            var flag = true;
            if (typeof _this._fn === "function") {
              flag = _this._fn();
            }
            if (flag !== false) {
              flag = true;
            }
            if (flag) {
              _this.close();
            }
          }
        }
      }, "确定")]);
      if (typeof _this._content === "function") {
        var result = _this._content(h);
        if (Array.isArray(result)) {
          return [].concat(_toConsumableArray(result), [foot]);
        } else {
          return [result, foot];
        }
      }
    }());
  }
};